var _path, _rect, _rect2, _circle, _path2, _line, _line2, _circle2, _path3, _line3, _line4, _path4, _path5, _path6, _path7, _path8, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiveLongMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 200 20 L 0 20 L 0 180 L 200 180",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 140,
    width: 140,
    height: 30,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 147.5,
    width: 60,
    height: 15,
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 155,
    r: 17.5,
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 157.5 145.5 L 172.5 147.5 L 172.5 163.5 L 157.5 164.5 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 167.5,
    y1: 153,
    x2: 180,
    y2: 153,
    stroke: "black",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 167.5,
    y1: 157,
    x2: 180,
    y2: 157,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 155,
    r: 17.5,
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 42.5 145.5 L 27.5 147.5 L 27.5 163.5 L 42.5 164.5 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 153,
    x2: 20,
    y2: 153,
    stroke: "black",
    strokeWidth: 2.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 157,
    x2: 20,
    y2: 157,
    stroke: "black",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 40 20 C 40 5, 60 5, 60 20",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 65 20 C 65 5, 85 5, 85 20",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 20 C 90 5, 110 5, 110 20",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 115 20 C 115 5, 135 5, 135 20",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 140 20 C 140 5, 160 5, 160 20",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 65,
    x2: 15,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 65,
    x2: 30,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 65,
    x2: 45,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 65,
    x2: 60,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 65,
    x2: 75,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 65,
    x2: 90,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 65,
    x2: 105,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 65,
    x2: 120,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 65,
    x2: 135,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 65,
    x2: 150,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 65,
    x2: 165,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 65,
    x2: 180,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 65,
    x2: 195,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 123,
    x2: 15,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 123,
    x2: 30,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 123,
    x2: 45,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 123,
    x2: 60,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 123,
    x2: 75,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 123,
    x2: 90,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 123,
    x2: 105,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 123,
    x2: 120,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 123,
    x2: 135,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 123,
    x2: 150,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 123,
    x2: 165,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 123,
    x2: 180,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 123,
    x2: 195,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveLongMiddle);
export default __webpack_public_path__ + "static/media/FiveLongMiddle.9b92ba58b35fea15f402392e948fac5e.svg";
export { ForwardRef as ReactComponent };